import React from 'react'

export const CSVReader = ({ onFileLoaded }) => {
  const handleChangeFile = (event) => {
    const reader = new FileReader()
    if (event.target.files.length > 0) {
      reader.onload = (event) => {
        const csvData = event.target.result
        onFileLoaded(csvData)
      }

      reader.readAsText(event.target.files[0], 'UTF-8')
    }
  }

  return (
    <div className="flex-center">
      <label className="balto-button brand">
        <input type="file" accept=".csv, text/csv" onChange={(event) => handleChangeFile(event)} />
        Upload CSV
      </label>
    </div>
  )
}
